module.exports = __webpack_public_path__ + "img/ymt.bf12de5e.png";